export const disposableEmailDomains = [
  '123mail.org',
  '126.com',
  '139.com',
  '150mail.com',
  '150ml.com',
  '163.com',
  '16mail.com',
  '2-mail.com',
  '420blaze.it',
  '4email.net',
  '50mail.com',
  '8chan.co',
  'aaathats3as.com',
  'airmail.cc',
  'airpost.net',
  'allmail.net',
  'antichef.com',
  'antichef.net',
  'bestmail.us',
  'bluewin.ch',
  'c2.hu',
  'cluemail.com',
  'cocaine.ninja',
  'cock.email',
  'cock.li',
  'cock.lu',
  'cumallover.me',
  'dfgh.net',
  'dicksinhisan.us',
  'dicksinmyan.us',
  'elitemail.org',
  'emailcorner.net',
  'emailengine.net',
  'emailengine.org',
  'emailgroups.net',
  'emailplus.org',
  'emailuser.net',
  'eml.cc',
  'f-m.fm',
  'fast-email.com',
  'fast-mail.org',
  'fastem.com',
  'fastemail.us',
  'fastemailer.com',
  'fastest.cc',
  'fastimap.com',
  'fastmail.cn',
  'fastmail.co.uk',
  'fastmail.com',
  'fastmail.com.au',
  'fastmail.es',
  'fastmail.fm',
  'fastmail.im',
  'fastmail.in',
  'fastmail.jp',
  'fastmail.mx',
  'fastmail.net',
  'fastmail.nl',
  'fastmail.se',
  'fastmail.to',
  'fastmail.tw',
  'fastmail.uk',
  'fastmail.us',
  'fastmailbox.net',
  'fastmessaging.com',
  'fea.st',
  'firemail.cc',
  'fmail.co.uk',
  'fmailbox.com',
  'fmgirl.com',
  'fmguy.com',
  'freemail.hu',
  'ftml.net',
  'getbackinthe.kitchen',
  'gmx.com',
  'gmx.us',
  'goat.si',
  'h-mail.us',
  'hailmail.net',
  'hitler.rocks',
  'horsefucker.org',
  'hush.ai',
  'hush.com',
  'hushmail.com',
  'hushmail.me',
  'imap-mail.com',
  'imap.cc',
  'imapmail.org',
  'inoutbox.com',
  'internet-e-mail.com',
  'internet-mail.org',
  'internetemails.net',
  'internetmailing.net',
  'jetemail.net',
  'justemail.net',
  'kakao.com',
  'letterboxes.org',
  'liamekaens.com',
  'mail-central.com',
  'mail-page.com',
  'mail2world.com',
  'mailandftp.com',
  'mailas.com',
  'mailbolt.com',
  'mailc.net',
  'mailcan.com',
  'mailforce.net',
  'mailftp.com',
  'mailhaven.com',
  'mailingaddress.org',
  'mailite.com',
  'mailmight.com',
  'mailnew.com',
  'mailsent.net',
  'mailservice.ms',
  'mailup.net',
  'mailworks.org',
  'memeware.net',
  'ml1.net',
  'mm.st',
  'mozmail.com',
  'myfastmail.com',
  'mymacmail.com',
  'naver.com',
  'neverbox.com',
  'nigge.rs',
  'nospammail.net',
  'nus.edu.sg',
  'onet.pl',
  'ownmail.net',
  'petml.com',
  'postinbox.com',
  'postpro.net',
  'proinbox.com',
  'promessage.com',
  'qq.com',
  'realemail.net',
  'reallyfast.biz',
  'reallyfast.info',
  'recursor.net',
  'redchan.it',
  'ruffrey.com',
  'rushpost.com',
  'safe-mail.net',
  'sent.as',
  'sent.at',
  'sent.com',
  'shitposting.agency',
  'shitware.nl',
  'sibmail.com',
  'sneakemail.com',
  'snkmail.com',
  'snkml.com',
  'spamcannon.com',
  'spamcannon.net',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'speedpost.net',
  'speedymail.org',
  'ssl-mail.com',
  'swift-mail.com',
  'tfwno.gf',
  'the-fastest.net',
  'the-quickest.com',
  'theinternetemail.com',
  'tweakly.net',
  'veryfast.biz',
  'veryspeedy.net',
  'waifu.club',
  'warpmail.net',
  'xoxy.net',
  'xwaretech.com',
  'xwaretech.info',
  'xwaretech.net',
  'xsmail.com',
  'yahoo.com.ph',
  'yahoo.com.vn',
  'yeah.net',
  'yepmail.net',
  'your-mail.com',
];
